export type DBaseStateMatcher = (state: string) => void | boolean;
